// CustomBarShape.tsx
import React, { FC } from 'react';
import { useTheme } from 'styled-components';

interface CustomBarShapeProps {
  x: number;
  y: number;
  width: number;
  height: number;
  fill: string;
  historicalScore: number | null;
  togglersState: { historical_result: boolean };
  maxBarHeight: number;
  surveyDate: string | null;
  onHover: (x: number, y: number, date: string) => void;
  onLeave: () => void;
}

const CustomBarShape: FC<CustomBarShapeProps> = ({
  x,
  y,
  width,
  height,
  fill,
  historicalScore,
  togglersState,
  maxBarHeight,
  surveyDate,
  onHover,
  onLeave,
}) => {
  const theme = useTheme();
  const value = historicalScore ? historicalScore : 0;
  const dotYPosition = maxBarHeight - (377 * value) / 100;

  return (
    <g>
      <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} />
      {togglersState.historical_result && historicalScore != null && (
        <line
          cursor="pointer"
          x1={x}
          x2={x + width}
          y1={dotYPosition}
          y2={dotYPosition}
          stroke={theme.colors.secondary[100]}
          strokeWidth={2}
          onMouseEnter={() => onHover(x + width / 2, dotYPosition, surveyDate || '')}
          onMouseLeave={onLeave}
        />
      )}
    </g>
  );
};

export default CustomBarShape;
